import React, { useState } from 'react';
import { Button } from '../../components/ui';
import './lanes.css';

/**
 * Shared "archive with a reason" modal (Tasks Rebuild Task 12), matching the
 * legacy Tasks.tsx archive dialog's validation (reason required, minimum 10
 * characters -- enforced both here and server-side by
 * `unifiedTasksApi.archiveTask`/`POST /ui/email-tasks/<id>/archive`).
 * Reused by `TaskDetailPane`'s single-task Archive action and the
 * Lender/Post lane bulk bars' Archive action (the only two bulk bars that
 * had an Archive stub -- ManualLane never did).
 */

export interface ArchiveReasonModalProps {
  title?: string;
  hint?: React.ReactNode;
  confirmLabel?: string;
  processing?: boolean;
  onConfirm: (reason: string) => void;
  onClose: () => void;
}

export const ArchiveReasonModal: React.FC<ArchiveReasonModalProps> = ({
  title = 'Archive task', hint, confirmLabel = 'Archive', processing, onConfirm, onClose,
}) => {
  const [reason, setReason] = useState('');
  const trimmed = reason.trim();

  return (
    <div className="lane-modal-backdrop" onClick={onClose}>
      <div className="lane-modal" onClick={(e) => e.stopPropagation()}>
        <h2 className="lane-modal__title">{title}</h2>
        {hint && <p className="lane-modal__hint">{hint}</p>}
        <div className="lane-modal__field">
          <label>Reason (minimum 10 characters):</label>
          <textarea
            className="lane-modal__input"
            rows={4}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Please provide a clear reason for archiving..."
            autoFocus
          />
          {trimmed.length > 0 && trimmed.length < 10 && (
            <div className="lane-modal__hint">
              Please provide a more detailed reason ({trimmed.length}/10 characters)
            </div>
          )}
        </div>
        <div className="lane-modal__actions">
          <Button variant="secondary" onClick={onClose} disabled={processing}>Cancel</Button>
          <Button
            variant="danger"
            onClick={() => onConfirm(trimmed)}
            disabled={processing || trimmed.length < 10}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ArchiveReasonModal;
